import { Component, TemplateRef, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { TwcBreadcrumbItem } from '@topcon/twc-angular';

import { MagnetService, TranslationService, UiConfigurationService } from '@mirage-projects/cw-commons';

import { BarListConfigurationService, ItemBar } from '@collageweb/services/bar-list-configuration.service';

import { AboutDialogComponent } from './about-dialog/about-dialog.component';

@Component({
    selector: 'cw-topbar',
    templateUrl: './topbar.component.html',
    styleUrls: ['./topbar.component.scss'],
    standalone: false,
})
export class TopbarComponent implements OnInit {
    breadcrumbs: TwcBreadcrumbItem[] = [];
    @ViewChild('aboutDialog') aboutDialog!: TemplateRef<AboutDialogComponent>;
    topBarItems: ItemBar[] = [];
    currentLanguage = '';
    appLogo = `${this.uiConfigurationService.uiConfiguration.imgFolder}Magnet_CollageWeb_Logo_Blue_RGB.svg`;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        public translationService: TranslationService,
        private barListConfigurationService: BarListConfigurationService,
        private uiConfigurationService: UiConfigurationService,
        private magnetService: MagnetService
    ) {}

    ngOnInit(): void {
        this.subscribeToRouteChange();

        // Reload breadcrumbs when change lang
        this.translationService.onChangeLanguage$.subscribe(() => {
            this.breadcrumbs = this.buildBreadcrumbs(this.activatedRoute);
        });
        this.topBarItems = this.barListConfigurationService.TOPBAR_ITEMS;

        if (this.magnetService.isEmbed() && this.uiConfigurationService.uiConfiguration.logo) {
            this.appLogo = this.uiConfigurationService.uiConfiguration.logo;
        }
    }

    buildBreadcrumbs(route: ActivatedRoute, url = '', breadcrumbs: TwcBreadcrumbItem[] = []): TwcBreadcrumbItem[] {
        let path: string | undefined = '';
        let title = '';
        let icon = '';
        if (route?.routeConfig?.data?.title) {
            path = `/${route.routeConfig.path}`;
            title = this.translationService.translate(route.routeConfig.data?.title);
            icon = route.routeConfig.data?.icon;
        }
        const nextUrl = `${url}${path}`;

        const breadcrumb: TwcBreadcrumbItem = {
            url: nextUrl,
            title,
        };

        if (icon) {
            breadcrumb.icon = icon;
        }
        if (path) {
            breadcrumbs.push(breadcrumb);
        }

        if (route.firstChild) {
            this.buildBreadcrumbs(route.firstChild, nextUrl, breadcrumbs);
        }

        return breadcrumbs;
    }

    isCurrentLang(pcvizLangCode: undefined | string): boolean {
        if (!pcvizLangCode) {
            return false;
        }
        const shortCode = pcvizLangCode.substring(0, 2);
        const twcLocale = this.translationService.getTwcLocale(shortCode);
        return this.translationService.currentLang === twcLocale;
    }

    private subscribeToRouteChange(): any {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.breadcrumbs = this.buildBreadcrumbs(this.activatedRoute);
            }
        });
    }
}
